import React from 'react';
import { motion } from "framer-motion";
import "./About.css"
import { useRef } from 'react';

import Images from "../../Constants/index.jsx";

const About = () => {
  const scrollRef = useRef(null);

  return (
    <div id='section2' className="about-container">

      <motion.div 
      initial={{
        y: 200,
        opacity: 0       
      }}
      whileInView={{
        y: 0,
        opacity: 1
      }}
      transition={{
        duration: 1
      }}
      viewport={{root: scrollRef}}
      className="about-content">
        <div className="about-desc">
          <h3>Déjame contarte sobre mi</h3>
          <p>Venezolano graduado en la mención de Tecnología Electrónica, con más de 2 años de experiencia laboral profesional desarrollando proyectos de Frontend y Backend utilizando las herramientas de Wordpress, Divi, Elementor, React, NodeJs y Bootstrap. Conocimiento medio-alto en HTML, CSS y Javascript y básicos en PHP, C++ y assembler, con gran capacidad para resolver problemas de lógica, comprendiendo el manejo del flujo HTML, animaciones CSS, y lógica de JavaScript (implementando JQuery o TypeScript). Con entendimiento básico de las bases de datos MySQL y MongoDB.</p>
          <br />
          <p>Experimentado en proyectos con tecnologías Node.js, React, Github, y Bootstrap. Estudio e implementación de API RESTful en NodeJs para el manejo de un ecommerce en React. Con disposición en aprender y aplicar nuevas técnicas que puedan ser aplicadas en otros lenguajes de programación como Phyton y PHP; así mismo, en Diseño web, UX – UI.</p>
        </div>
        <div className="about-img">
          <img src={Images.about} alt="About" />
        </div>
      </motion.div>

    </div>
  )
}

export default About